<script setup lang="ts">
import { boundaryErrorReporter } from '~/utilities/ui-utilities';
import { useTemplateRef } from 'vue';
import ErrorNotice from '~/components/user-interface/error-notice.vue';

interface Props {
  componentBoundary: string;
  file: string;
  showError?: boolean;
}

const { $t } = useNuxtApp();

withDefaults(defineProps<Props>(), {
  showError: true,
});

const errorBoundary = useTemplateRef('errorBoundary');
</script>

<template>
  <NuxtErrorBoundary
    ref="errorBoundary"
    @error="
      (err) =>
        boundaryErrorReporter({
          file,
          componentBoundary,
          err,
        })
    "
  >
    <slot />
    <template #error>
      <error-notice v-if="showError">
        <template #icon>
          <DesignSystemIconsMaintenanceIcon
            class="w-20 md:w-28 relative z-10"
          />
        </template>
        <template #title>{{ $t('error') }}</template>
        <template #message>{{ errorBoundary.error }}</template>
        <template #actions>
          <DesignSystemButton @click="errorBoundary.clearError()">
            {{ $t('try-again') }}
          </DesignSystemButton>
        </template>
      </error-notice>
    </template>
  </NuxtErrorBoundary>
</template>
